import { HttpClient } from '../clients';

class SuggestionService {
  static delete(id, deleteThumbnail = false) {
    return HttpClient.delete(`/suggestions/${id}`, { params: { deleteThumbnail } });
  }
}

export { SuggestionService };
